
import { combineReducers } from 'redux';
import configuration from './configure-reducer';
import itineraries from './itineraries-reducer';
import revenueInsights from './revenueInsignts-reducer';
import editAppKey from './partner-settings/edit-app-key-configuration-reducer';
import productMappings from './partner-settings/product-mappings-reducer';
import aiRules from './ai-rules-reducer';
import partnerSettings from './partner-settings/reducer';
import apiKeys from './api-keys-reducer';
import importFilters from './import-filters-reducer';
import statusCheck from './status-check-reducer';
import downloadXLSXReducer from '../ItineraryAssist/downloads/dowloads-reducer';
import gondola from '../Settings/Gondola/__store__/gondola-reducer';
import integrationSettings from './integration-settings-reducer';
import learning from './learning-reducer';

export default combineReducers({
  configuration,
  itineraries,
  revenueInsights,
  editAppKey,
  productMappings,
  aiRules,
  partnerSettings,
  apiKeys,
  importFilters,
  statusCheck,
  downloadXLSXReducer,
  gondola,
  integrationSettings,
  learning,
})
